module.exports = __webpack_public_path__ + "static/media/section_3_C.7def098a.png";